export const CORTEVA_MANUAL_SEGMENTS = {
  crc: {
    label: "CRC Staff",
    description: "CRC Staff Salaries & Benefits Reimbursement (as per attached sheet)",
    costFields: ["salary", "gli", "pessi", "eobi"],
    rows: [
      { code: "C10375", name: "Muhammad Siddique", designation: "Tea Boy", salary: 48507, gli: 140, pessi: 2664, eobi: 2000, serviceFee: 1250, days: 30 },
      { code: "C10376", name: "Zulfiqar Ali", designation: "Baildar (CRC-Farm operations)", salary: 48507, gli: 140, pessi: 2664, eobi: 2000, serviceFee: 1250, days: 30 },
      { code: "C10377", name: "Waseem", designation: "Janitorial Service Boy", salary: 48507, gli: 140, pessi: 2664, eobi: 2000, serviceFee: 1250, days: 30 },
      { code: "C10598", name: "Muhammad Khalid", designation: "Gardener", salary: 50274, gli: 140, pessi: 2664, eobi: 2000, serviceFee: 1250, days: 30 },
      { code: "C10378", name: "Shahid Mehmood", designation: "Baildar (CRC-Farm operations)", salary: 48507, gli: 140, pessi: 2664, eobi: 2000, serviceFee: 1250, days: 30 }
    ]
  },
  graphic: {
    label: "Graphic Designer",
    description: "Graphic Designer Salaries & Benefits Reimbursement (as per attached sheet)",
    costFields: ["salary", "conveyance", "gli", "health", "eobi"],
    rows: [{ code: "C10537", name: "M. Haris Ijaz", designation: "Graphic Designer", cnic: "35202-3558912-3", contact: "0332-4193694", joined: "07-04-2025", location: "Lahore", salary: 136800, conveyance: 25000, gli: 140, health: 2200, eobi: 2000, serviceFee: 1250, days: 30 }]
  },
  cre: {
    label: "CRE",
    description: "Customer Relationship Executive Salaries & Benefits Reimbursement (as per attached sheet)",
    costFields: ["salary", "conveyance", "mobile", "gli", "health", "eobi"],
    rows: [{ code: "C10644", name: "Anam Saad", designation: "Customer Relationship Executive", cnic: "31102-0875855-2", contact: "0309-6593969", joined: "02-01-2026", location: "Lahore", salary: 90000, conveyance: 25000, mobile: 4000, gli: 140, health: 2200, eobi: 2000, serviceFee: 1250, days: 30 }]
  },
  consultant: {
    label: "Consultant",
    description: "Consultant Services Reimbursement (as per attached sheet)",
    costFields: ["salary", "conveyance", "mobile", "gli", "health", "eobi"],
    rows: [{ code: "C10035", name: "Dr. Abdul Aziz", designation: "Consultant", cnic: "34101-5363987-7", contact: "0303-5876484", joined: "01-04-2022", location: "Lahore", salary: 271955, conveyance: 0, mobile: 0, gli: 0, health: 2200, eobi: 0, serviceFee: 1250, days: 30 }]
  },
  dispatch: {
    label: "Dispatch Rider",
    description: "Dispatch Rider Salaries & Benefits Reimbursement (as per attached sheet)",
    // "otAmount" is deliberately NOT in costFields anymore — it's computed
    // from salary and the operator-entered otHours (see computeDispatchOt()
    // below), not typed in directly. Fuel stays the same computed pattern:
    // litres (default 40) × operator-entered rate per litre.
    costFields: ["salary", "vehicle", "mobile", "conveyance", "fuelLitres", "fuelPrice", "gli", "socialSecurity", "eobi"],
    rows: [{ code: "C10042", name: "Syed Faisal Nousher", designation: "Dispatch Rider", cnic: "36502-9346399-7", contact: "0302-6666764", joined: "15-07-2022", location: "Lahore", salary: 54259, otHours: 35, vehicle: 4500, mobile: 2000, conveyance: 25000, fuelLitres: 40, fuelPrice: 272, gli: 140, socialSecurity: 2664, eobi: 2000, serviceFee: 1250, days: 31 }]
  }
};

export const COST_LABELS = {
  salary: "Basic salary", gli: "GLI", pessi: "PESSI", eobi: "EOBI", conveyance: "Conveyance", health: "Health insurance",
  mobile: "Mobile allowance", vehicle: "Vehicle maintenance", otAmount: "OT amount", otHours: "OT hours", fuelLitres: "Fuel litres", fuelPrice: "Fuel price per litre", socialSecurity: "Social Security"
};

// OT is computed, not entered directly: Basic Salary / 26 working days = per
// day rate; / 8 hours = per hour rate; × 2 = the OT rate; × the
// operator-entered hours = OT Amount.
export function computeDispatchOtRate(salary) {
  return (Number(salary || 0) / 26 / 8) * 2;
}
export function computeDispatchOtAmount(row) {
  return Math.round(computeDispatchOtRate(row.salary) * Number(row.otHours || 0));
}

export function cortevaManualRowCost(row, segment) {
  const fields = CORTEVA_MANUAL_SEGMENTS[segment]?.costFields || [];
  const other = fields.filter((field) => field !== "fuelLitres" && field !== "fuelPrice")
    .reduce((sum, field) => sum + Number(row[field] || 0), 0);
  const fuel = segment === "dispatch" ? Number(row.fuelLitres || 0) * Number(row.fuelPrice || 0) : 0;
  const ot = segment === "dispatch" ? computeDispatchOtAmount(row) : 0;
  return Math.round((other + fuel + ot) * 100) / 100;
}

export function cortevaManualTotals(rows, segment) {
  const reimbursement = Math.round(rows.reduce((sum, row) => sum + cortevaManualRowCost(row, segment), 0) * 100) / 100;
  const serviceCharges = Math.round(rows.reduce((sum, row) => sum + Number(row.serviceFee || 0), 0) * 100) / 100;
  const gst = Math.round(serviceCharges * 0.16);
  return { reimbursement, serviceCharges, gst, total: reimbursement + serviceCharges + gst };
}

// Maps each segment's configurable costFields to a normalized LINE_CATEGORY
// (see lineCategories.js) — segments vary (CRC has "pessi", Dispatch has
// "socialSecurity" for the same concept, only some have "health", etc.), so
// this has to be a lookup rather than a fixed handful of named fields like
// cortevaWorkbook.js's Excel-upload path uses.
const FIELD_CATEGORY = {
  salary: "SALARY_REIMBURSEMENT",
  eobi: "EOBI_RECOVERY",
  pessi: "PESSI_RECOVERY",
  socialSecurity: "PESSI_RECOVERY",
  gli: "GLI_RECOVERY",
  health: "INSURANCE_RECOVERY",
  conveyance: "SALARY_REIMBURSEMENT",
  mobile: "SALARY_REIMBURSEMENT",
  vehicle: "SALARY_REIMBURSEMENT",
  otAmount: "SALARY_REIMBURSEMENT"
};

// Per-category totals behind cortevaManualTotals()'s single `reimbursement`
// figure — same purpose as cortevaWorkbook.js's reimbursementBreakdown, kept
// alongside (not instead of) the flat total.
export function cortevaManualBreakdown(rows, segment) {
  const fields = CORTEVA_MANUAL_SEGMENTS[segment]?.costFields || [];
  const totals = {};
  const add = (category, amount) => {
    if (!amount) return;
    totals[category] = Math.round(((totals[category] || 0) + amount) * 100) / 100;
  };
  rows.forEach((row) => {
    fields.forEach((field) => {
      const category = FIELD_CATEGORY[field];
      if (category) add(category, Number(row[field] || 0));
    });
    if (fields.includes("fuelLitres") && fields.includes("fuelPrice")) {
      add("SALARY_REIMBURSEMENT", Number(row.fuelLitres || 0) * Number(row.fuelPrice || 0));
    }
    if (segment === "dispatch") {
      add("SALARY_REIMBURSEMENT", computeDispatchOtAmount(row));
    }
  });
  return totals;
}
